import { Button, Grid, TextField, ThemeProvider } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CallIcon from "@material-ui/icons/Call";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MusicVideoOutlinedIcon from "@material-ui/icons/MusicVideoOutlined";
import AudioPlayer from "material-ui-audio-player";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import {
  addCommunicatioTimeLinePath,
  getDate,
  getTime,
  prospectDetailsPath,
  toHHMMSS,
  investorAddCommunicatioTimeLinePath,
  investmentDetailsPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import EmailIcon from "@material-ui/icons/Email";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import staticFiles from "../services/staticApi";
import excel from "../assets/excel_logo.svg";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    width: "30px",
    height: "30px",
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const CommunicationTimeLine = () => {
  const muiTheme = createTheme({});
  const [open, setOpen] = React.useState(false);
  const [audioLink, setAudioLink] = React.useState("");
  const [showimage, setShowimage] = React.useState("");
  const [showimageopen, setShowimageopen] = React.useState("");

  const location = useLocation();
  const myparam = location.state;
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [timeLineData, setTimeLineData] = useState([]);
  const [mailData, setmailData] = useState([]);
  const [communicationLogData, setcommunicationLogData] = useState([]);

  const [editComment, setEditComment] = useState(false);
  const [disableUpdateBtn, setDisableUpdateBtn] = useState(false);
  const [commentValue, setCommentValue] = useState({
    id: "",
    comment: "",
  });
  const gotoProspectDetails = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };
  const changeComment = (e) => {
    e.preventDefault();
    setCommentValue({
      ...commentValue,
      comment: e.target.value,
    });
  };
  const openCommentModel = (e, row) => {
    if (row && row.id) {
      setCommentValue({
        id: row.id,
        comment: row.comment,
      });
      setEditComment(true);
      setDisableUpdateBtn(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setEditComment(false);
    setShowimageopen(false);
  };
  const submitComment = (e) => {
    setDisableUpdateBtn(true);
    http
      .patch("/updatecallcomment?id=" + commentValue.id, {
        comment: commentValue.comment,
      })
      .then((res) => {
        if (res.data && res.data.statusCode == 0) {
          setEditComment(false);
          setDisableUpdateBtn(false);
          getData();
        } else {
          setDisableUpdateBtn(false);
        }
      })
      .catch((err) => {});
  };
  const getData = () => {
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      let cust_id = myparam.cust__id || myparam.customer_id;
      http
        .get("/calldata?cust_id=" + cust_id)
        .then((res) => {
          // (res);
          if (
            res &&
            res.data &&
            res.data.Calldata &&
            Array.isArray(res.data.Calldata) &&
            res.data.Calldata.length > 0
          ) {
            setTimeLineData(res.data.Calldata);
          }
          if (
            res &&
            res.data &&
            res.data.Mail_Data &&
            Array.isArray(res.data.Mail_Data) &&
            res.data.Mail_Data.length > 0
          ) {
            setmailData(res.data.Mail_Data);
          }
          if (
            res &&
            res.data &&
            res.data.Communication_Log &&
            Array.isArray(res.data.Communication_Log) &&
            res.data.Communication_Log.length > 0
          ) {
            setcommunicationLogData(res.data.Communication_Log);
          }
        })
        .catch((err) => {});
    } else {
      history.goBack();
    }
  };
  const gotoAddCommunication = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addCommunicatioTimeLinePath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorAddCommunicatioTimeLinePath,
        state: myparam,
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const playAudio = (e, link) => {
    setAudioLink("");
    if (link && link !== "") {
      setAudioLink(link);
      setOpen(true);
    }
  };

  const playRecordAudio = (e, link) => {
    setAudioLink("");
    if (link && link !== "") {
      setAudioLink(staticFiles + link);
      setOpen(true);
    }
  };

  const showimagepopup = (e, link) => {
    setShowimage("");
    if (link && link !== "") {
      setShowimage(link);
      // (setShowimage(link));
      setShowimageopen(true);
    }
  };

  return (
    <Grid
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
    >
      {/* <Paper className={classes.root,"paper"}>
                <Grid container>
                    <Grid item xs={12} sm={6} md={1}>
                        <Button name="Overview" variant="contained" color="primary" onClick={gotoProspectDetails}>Overview</Button>
                    </Grid>
                </Grid>
            </Paper> */}
      <Grid container style={{ marginTop: "10px" }}>
        {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoProspectDetails}>Back</Button>
            </Grid> */}
        {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Typography variant="h6">Communication Timeline</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1}>
          <Typography variant="h6">
            <Button
              type="submit"
              color="primary"
              style={{ borderRadius: "100px" }}
              variant="contained"
              size="small"
              onClick={gotoAddCommunication}
            >
              <AddCircleOutlineIcon />
            </Button>
          </Typography>
        </Grid> */}
        <h1 style={{ fontSize: 20, color: "#08054e" }}>
          Communication Timeline{" "}
          <Button
            type="submit"
            color="primary"
            style={{ borderRadius: "100px" }}
            variant="contained"
            size="small"
            onClick={gotoAddCommunication}
          >
            <AddCircleOutlineIcon />
          </Button>
        </h1>
      </Grid>
      <Stepper orientation="vertical" nonLinear defaultColor="primary">
        {communicationLogData.map((label, index) => {
          return (
            <Step key={label.id} active>
              <StepLabel
                icon={
                  <div className={classes.circle}>
                    <CallIcon
                      style={{ width: "20px", height: "20px", margin: "4px" }}
                    />
                  </div>
                }
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    edge="start"
                  >
                    <div
                      style={{
                        display: "flex",
                        // flex: 5,
                        justifyContent: "space-around",
                      }}
                    >
                      <div>
                        <p>Call Duration</p>
                        <p>
                          {label.duration ? toHHMMSS(label.duration) : "N/A"}
                        </p>
                      </div>

                      <div>
                        <p>Time</p>
                        <p>{label.time ? label.time : "N/A"}</p>
                      </div>

                      <div>
                        {/* <p>Communication Mode</p> */}
                        <p>Proof</p>
                        <p>
                          {label.communicationmode === "whatsapp" ? (
                            <Grid>
                              {label.proof && (
                                <Typography
                                  variant="h6"
                                  style={
                                    label.proof && label.proof === ""
                                      ? {}
                                      : { cursor: "pointer" }
                                  }
                                  onClick={(e) => {
                                    showimagepopup(
                                      e,
                                      staticFiles + label.proof
                                    );
                                  }}
                                >
                                  <img
                                    className="whatsappimg"
                                    src={staticFiles + label.proof}
                                    alt="img"
                                    style={
                                      label.proof && label.proof === ""
                                        ? {}
                                        : { cursor: "pointer" }
                                    }
                                  />
                                </Typography>
                              )}
                            </Grid>
                          ) : "N/A"}

                          {/* {label.communicationmode === "call" ? ( */}

                          {label.communicationmode === "call" && label.proof ? (
                            <>
                              {["mp3", "aac", "ogg", "wav", "flac", "mpeg", "aiff", "dsd"].includes(
                                label.proof.split(".")[1]
                              ) ? (
                                <Grid item xs={12} sm={2} md={1}>
                                  <Typography
                                    variant="h6"
                                    style={
                                      label.proof && label.proof === ""
                                        ? {}
                                        : { cursor: "pointer" }
                                    }
                                    onClick={(e) => {
                                      playRecordAudio(e, label.proof);
                                    }}
                                  >
                                    <MusicVideoOutlinedIcon />
                                  </Typography>
                                </Grid>
                              ) : [
                                  "png",
                                  "jpg",
                                  "jpeg",
                                  "gif",
                                  "webp",
                                ].includes(label.proof.split(".")[1]) ? (
                                <Typography
                                  variant="h6"
                                  style={
                                    label.proof && label.proof === ""
                                      ? {}
                                      : { cursor: "pointer" }
                                  }
                                  onClick={(e) => {
                                    showimagepopup(
                                      e,
                                      staticFiles + label.proof
                                    );
                                  }}
                                >
                                  <img
                                    className="whatsappimg"
                                    src={staticFiles + label.proof}
                                    alt="img"
                                    style={
                                      label.proof && label.proof === ""
                                        ? {}
                                        : { cursor: "pointer" }
                                    }
                                  />
                                </Typography>
                              ) : (
                                "N/A"
                              )}
                            </>
                          ) : null}

                          {label.communicationmode === "walkin" ? (
                            <Grid>{label.communicationmode ? label.communicationmode : "N/A"}</Grid>
                          ) : null}
                        </p>
                      </div>

                      <div>
                        <p>PF workbook</p>
                        {label.pf_workbook ? (
                          <a href={staticFiles + label.pf_workbook} download>
                            <img
                              src={excel}
                              alt="excelLogo"
                              style={{
                                width: 100,
                                height: 50,
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>

                      <div>
                        <p>Date</p>
                        <p>{label.date ? label.date : "N/A"}</p>
                      </div>

                      <div>
                        <p>Executive Name</p>
                        <p>
                          {label.executive_name ? label.executive_name : "N/A"}
                        </p>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={10}
                        md={10}
                        style={{
                          backgroundColor: "#CACACA",
                          padding: "10px",
                        }}
                      >
                        <Typography>Comment</Typography>
                        <Typography variant="body1">
                          {label.comments}
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Stepper orientation="vertical" nonLinear defaultColor="primary">
        {timeLineData.map((label, index) => {
          return (
            <Step key={label.id} active>
              <StepLabel
                icon={
                  <div className={classes.circle}>
                    <CallIcon
                      style={{ width: "20px", height: "20px", margin: "4px" }}
                    />
                  </div>
                }
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    edge="start"
                  >
                    <Grid container style={{ marginTop: "10px" }}>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography variant="caption">Mobile Number</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        <Typography variant="caption">Status</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        <Typography variant="caption">Call Duration</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        <Typography variant="caption">Play Audio</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography variant="caption">
                          Executive Name
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography variant="caption">Time</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {getDate(label.time)}
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {label.mobile}
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        {label.status}
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        {toHHMMSS(label.call_duration)}
                      </Grid>
                      <Grid item xs={12} sm={2} md={1}>
                        <Typography
                          variant="h6"
                          style={
                            label.audio && label.audio === ""
                              ? {}
                              : { cursor: "pointer" }
                          }
                          onClick={(e) => {
                            playAudio(e, label.audio);
                          }}
                        >
                          {label.audio ? <MusicVideoOutlinedIcon /> : <p style={{fontSize:14}}>N/A</p>}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {label.executive_name}
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {getTime(label.time)}
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={10}
                        md={10}
                        style={{
                          backgroundColor: "#CACACA",
                          padding: "10px",
                        }}
                      >
                        <Typography>Comment</Typography>
                        <Typography variant="body1">{label.comment}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} align="center">
                        <Button onClick={(e) => openCommentModel(e, label)}>
                          <EditOutlinedIcon style={{ cursor: "pointer" }} />
                        </Button>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>      
      <Stepper orientation="vertical" nonLinear defaultColor="primary">
        {mailData.map((label, index) => {
          return (
            <Step key={label.id} active>
              <StepLabel
                icon={
                  <div className={classes.circle}>
                    <EmailIcon
                      style={{ width: "20px", height: "20px", margin: "4px" }}
                    />
                  </div>
                }
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    edge="start"
                  >
                    <Grid container style={{ marginTop: "10px" }}>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography variant="caption">From</Typography>
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        <Typography variant="caption">To</Typography>
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        <Typography variant="caption">Subject</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography variant="caption">Time</Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} align="rigth">
                        {getDate(label.date)}
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {label.from_mail}
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        {label.to_mail}
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        {label.sub}
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        {getTime(label.created_at)}
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={10} md={10}>
                        <Typography>Transcript</Typography>
                        <Typography
                          variant="body1"
                          style={{
                            backgroundColor: "#CACACA",
                            padding: "10px",
                          }}
                        >
                          {label.mes}
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Play Audio
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <ThemeProvider theme={muiTheme}>
              <AudioPlayer
                src={audioLink}
                elevation={1}
                width="100%"
                variation="default"
                spacing={3}
                autoplay={true}
                order="standart"
                preload="auto"
              />
            </ThemeProvider>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showimageopen}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogContent>
          <DialogContentText>
            <img
              src={showimage}
              alt="img"
              style={{ width: "100%", height: "100%" }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editComment}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Update Comment
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextField
              multiline
              autoFocus
              rows={5}
              variant="outlined"
              value={commentValue.comment}
              onChange={changeComment}
              fullWidth
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={(e) => submitComment(e)}
            variant="contained"
            color="primary"
            disabled={disableUpdateBtn}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default CommunicationTimeLine;
